/* eslint-disable react/no-danger */
import React, { useState } from "react"

import januszImage from "@assets/images/people/janusz-bryzek.png"
import { PageSection } from "@components/sections"
import { CONSTANTS } from "@data"
import { GridLines, Headline, ContentRow, CTA } from "@shared"
import { css } from "@jsUtils"
import Styles from "./bannerHome.module.scss"

const { THEMES, COLORS } = CONSTANTS

const BannerHome = props => {
  const { color } = props

  const [ready, setReady] = useState(false)

  const person = {
    name: "Janusz Bryzek, Ph.D.",
    photo: januszImage,
    dates: "1947 - 2022",
    description: `Our hearts are broken by the loss of our Co-Founder and Board Chairman, Janusz Bryzek, Ph.D. Often seen as the “Father of Sensors” and the "Trillion Sensor Man," Janusz shaped the world with the ideas he brought forward. His larger-than-life presence was matched only by his kindness and generosity. Janusz will be deeply missed by all.`
  }

  return (
    <PageSection
      theme={THEMES.DARK}
      ready={ready}
      className={css(ready && Styles.ready, Styles.heroSection)}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={THEMES.DARK} />
      <div className={Styles.heroGradient} />
      <ContentRow tagname="div" extraClass={css(Styles.heroWrapperRow)}>
        <div className={css(Styles.heroImageContainer)}>
          <img src={person.photo} alt={person.name} className={Styles.heroPhoto} />
        </div>
        <div className={css(ready && Styles.ready, Styles.pageHeadingContentColumn)}>
          <Headline size={1} emColor={color} className={css(Styles.headerText)}>
            {person.name}
          </Headline>
          <Headline size={2} className={css(Styles.subhead)} subhead="Sub title">
            {person.dates}
          </Headline>
          <Headline size={6} className={css(Styles.description)}>
            {person.description}
          </Headline>
          <div className={Styles.cta}>
            <CTA
              to="https://www.exo.inc/press-release/co-founder-of-exo-r-and-father-of-sensors-technology-dr-janusz-bryzek-passes/"
              color={COLORS.FLURO}
              ready
            >
              Read More
            </CTA>
          </div>
        </div>
      </ContentRow>
    </PageSection>
  )
}

export default BannerHome
